var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple360Desktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 116,
    viewBox: "0 0 594 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 116
  }, /*#__PURE__*/React.createElement("rect", {
    width: 594,
    height: 116,
    rx: 16,
    fill: "#190033"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M619.23 14.8436C668.254 14.24 741.544 5.09283 749.188 21.917C756.969 38.8237 699.104 81.7018 668.687 114.696C638.271 147.69 635.18 170.816 623.365 211.375C611.427 251.951 590.778 310.059 556.623 322.872C522.468 335.686 474.808 303.205 433.722 275.079C392.5 246.87 357.865 223.115 336.279 191.735C314.679 160.256 306.276 121.332 324.072 91.7684C341.881 62.3034 386.011 42.1809 423.022 28.3741C460.033 14.5672 490.047 7.05927 517.618 7.25035C545.066 7.45805 570.083 15.4638 619.23 14.8436Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M668.319 18.9671C707.686 25.0103 767.437 25.816 771.733 43.6434C776.13 61.5714 725.072 96.521 697.095 125.327C669.118 154.132 664.122 176.794 650.234 215.672C636.245 254.55 613.364 309.744 584.588 317.902C555.811 326.06 521.14 287.183 491.265 253.542C461.289 219.801 436.11 191.399 422.222 157.154C408.333 122.809 405.835 82.8232 423.321 55.7297C440.806 28.7369 478.375 14.6362 509.55 5.87362C540.724 -2.88895 565.603 -6.31341 587.685 -2.38536C609.667 1.5427 628.851 12.924 668.319 18.9671Z",
    fill: "#B2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M468.341 360.638C505.05 376.158 556.415 406.79 569.346 393.962C582.416 381.101 557.052 324.781 548.174 285.754C539.295 246.726 546.818 224.94 555.188 184.776C563.473 144.56 572.659 85.8826 552.365 63.9011C532.071 41.9195 482.296 56.6341 439.333 69.4321C396.233 82.2629 359.998 93.0919 330.352 114.779C300.654 136.552 277.735 169.065 278.559 201.146C279.434 233.141 304.136 264.757 326.161 288.507C348.186 312.256 367.619 328.191 388.489 336.441C409.274 344.639 431.548 345.066 468.341 360.638Z",
    fill: "#B2E7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple360Desktop);
export default __webpack_public_path__ + "static/media/Purple360Desktop.ce9ab648bf52bfaef045acf24dd6df40.svg";
export { ForwardRef as ReactComponent };